import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/ecommerce.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Ecommerce() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Custom Website Design",
            content: "We create visually appealing, on-brand designs that reflect your business identity and captivate your audience.",
        },
        {
            title: "Seamless Navigation",
            content: "Our user-friendly navigation ensures a smooth and enjoyable shopping experience, helping customers find products easily and make quick purchases.",
        },
        {
            title: "Inventory Management",
            content: "Keep track of your products with automated inventory management solutions that streamline stock control and order processing.",
        },
        {
            title: "Mobile Optimization",
            content: "Our eCommerce sites are fully optimized for mobile, allowing your customers to shop effortlessly from any device.",
        },
        {
            title: "SEO Optimization",
            content: "We ensure your eCommerce website is optimized for search engines to increase visibility and drive organic traffic.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Scalable Solutions",
            desc: "As your business grows, so will your online store. Our platforms are built to scale, ensuring that you can add new features, products, and functions as needed.",
        },
        {
            title: "Secure & Reliable",
            desc: "With top-tier security measures in place, we ensure that customer data and transactions are protected, giving you peace of mind.",
        },
        {
            title: "Integrated Features",
            desc: "We offer a range of integrated features such as CRM tools, marketing automation, and analytics to enhance your customer relationship and improve business insights.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        AOS.init({
            duration: 1200, // fade duration for all (ms)
            easing: "ease-in-out", // smooth effect
            once: true,
        });
    }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>E commerce Website

                            </h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/ecommerce">E commerce Website

                                </a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image" data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content" data-aos="fade-right">
                            <h1>E commerce Website Services</h1>

                            <p>
                                Unlock the full potential of online sales with REDITE’s eCommerce website services. We specialize in building powerful, user-friendly, and secure eCommerce platforms designed to provide a seamless shopping experience and drive business growth.
                            </p>

                            <h3>Tailored eCommerce Solutions for Your Business</h3>


                            <p>
                                At REDITE, we understand that every business is unique, which is why our eCommerce solutions are fully customized to meet your specific needs. Whether you’re launching a new online store or enhancing an existing one, we deliver an intuitive, scalable platform that supports your business objectives and maximizes sales.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>
                                Our eCommerce Website Services</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>Why Choose REDITE for Your eCommerce Website?</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Process: From Concept to Launch</h4>
                        <p>
                           We work closely with you to understand your business and customer needs. From the initial concept and design to development and launch, we handle every step of the process to ensure a smooth and successful eCommerce website that reflects your brand and drives sales.
                        </p>

                        <h4>Ready to Launch Your Online Store?</h4>
                     

                        <p>
                            Whether you’re starting from scratch or looking to upgrade your existing online store, 
                            <span> REDITE is here to help. </span> Our expert team provides cutting-edge eCommerce solutions that deliver measurable results.
                            <span> Contact us today to get started and take your business to new heights!</span>
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Ecommerce;
